import React, { useState, useEffect, useRef } from 'react';
import { ChevronRight, CheckSquare, Square } from './Icons';
import { baseData } from '../data/mockData';

const MultiSelectBase = ({ selectedIds, onChange, placeholder = "请选择所属基地 (可多选)..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleSelection = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter(item => item !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const selectedNames = baseData
    .filter(b => selectedIds.includes(b.id))
    .map(b => b.name)
    .join(', ');

  return (
    <div className="relative" ref={containerRef}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm bg-white cursor-pointer flex justify-between items-center min-h-[42px]"
      >
        <span className={`block truncate mr-2 ${selectedIds.length ? 'text-slate-800' : 'text-slate-400'}`}>
          {selectedIds.length > 0 ? selectedNames : placeholder}
        </span>
        <ChevronRight size={16} className={`transform transition-transform text-slate-400 shrink-0 ${isOpen ? 'rotate-90' : ''}`} />
      </div>
      
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {baseData.map(base => {
            const isSelected = selectedIds.includes(base.id);
            return (
              <div 
                key={base.id}
                onClick={() => toggleSelection(base.id)}
                className="flex items-center gap-3 px-3 py-2.5 hover:bg-slate-50 cursor-pointer text-sm"
              >
                {isSelected ? <CheckSquare size={16} className="text-blue-600" /> : <Square size={16} className="text-slate-300" />}
                <span className={isSelected ? 'text-blue-600 font-medium' : 'text-slate-600'}>{base.name}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectBase;
